import './index.scss';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeLogin } from '@actions/authActions';
import { Button, Paper, TextField } from '@material-ui/core';
import { translate } from '@utils';
import { Credentials } from '@types';
import { LogoMG } from '@images/icons';

const LoginPage = () => {
  const [formValue, setFormValue] = useState<Credentials>({
    username: '',
    password: '',
  });

  const [formError, setFormError] = useState({ username: false, password: false });

  const { username, password } = formValue;
  const { username: usernameError, password: passwordError } = formError;
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValue((prevState) => ({ ...prevState, [name]: value }));
    setFormError((prevState) => ({ ...prevState, [name]: false }));
  };

  const submitForm = (event) => {
    event.preventDefault();

    if (username === '') {
      setFormError((prevState) => ({ ...prevState, username: true }));
    } else {
      setFormError((prevState) => ({ ...prevState, username: false }));
    }

    if (password === '') {
      setFormError((prevState) => ({ ...prevState, password: true }));
    } else {
      setFormError((prevState) => ({ ...prevState, password: false }));
    }

    username && password && dispatch(makeLogin(formValue));
  };

  return (
    <div className="login-page-wrapper">
      <Paper className="login-form-wrapper">
        <form className="login-form" onSubmit={submitForm}>
          <div className="login-form-title">
            <LogoMG />
          </div>
          <label data-testid={'login-username-label'} className="login-form-label">
            {translate('username')}
          </label>
          <TextField
            data-testid={'login-username-input'}
            color="secondary"
            className="login-form-input username-field"
            onChange={handleChange}
            name="username"
            variant="outlined"
            error={usernameError}
            helperText={usernameError ? 'Username is required' : ''}
          />
          <label className="login-form-label">{translate('password')}</label>
          <TextField
            data-testid={'login-password-input'}
            className="login-form-input password-field"
            onChange={handleChange}
            type="password"
            name="password"
            variant="outlined"
            autoComplete="on"
            error={passwordError}
            helperText={passwordError ? 'Password is required' : ''}
          />
          <Button data-testid={'login-submit-button'} className="login-button" type="submit">
            {translate('login')}
          </Button>
        </form>
      </Paper>
    </div>
  );
};

export { LoginPage };
